// Sticky bar voor single-vacature template — verschijnt na 80vh scroll.

const init = () => {
	const root = document.querySelector( '[data-vacature-single]' );
	if ( ! root ) return;

	const sticky = root.querySelector( '[data-vacature-sticky]' );
	const hero   = root.querySelector( '.o-vacature__hero' );
	if ( ! sticky || ! hero ) return;

	const observer = new IntersectionObserver(
		( entries ) => {
			entries.forEach( ( entry ) => {
				if ( entry.isIntersecting ) {
					sticky.removeAttribute( 'data-visible' );
					sticky.setAttribute( 'aria-hidden', 'true' );
				} else {
					sticky.setAttribute( 'data-visible', '' );
					sticky.setAttribute( 'aria-hidden', 'false' );
				}
			} );
		},
		{ threshold: 0, rootMargin: '-100px 0px 0px 0px' }
	);

	observer.observe( hero );
};

init();
